var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',{staticClass:"animate-pulse block bg-gray-200",class:{
    'rounded-md': _vm.rounded,
    'max-w-full': _vm.maxWidth,
    'max-h-full': _vm.maxHeight,
  }})
}
var staticRenderFns = []

export { render, staticRenderFns }